import {css} from 'lit'; export default css`.sds-modal sds-tabs::part(sds-tab-content){display:block;padding:24px}.sds-overlay-appended{transform:translate3d(0,0,0)}`;
    